export default "__VITE_ASSET__BJB4Lnov__"